"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("circle", { cx: "18.064", cy: "18.449", r: "2.083" }),
  React.createElement("path", { d: "M20.865.409l.1 2.843a2.318 2.318 0 0 0 1.186 1.938l2.482 1.39-2.843.1a2.318 2.318 0 0 0-1.938 1.184l-1.39 2.482-.1-2.843a2.318 2.318 0 0 0-1.184-1.938l-2.482-1.39 2.843-.1a2.318 2.318 0 0 0 1.936-1.185zM26 22v2.923a10.474 10.474 0 0 0-4.538-1.623c-2.388 0-4.074 3.25-6.462 3.25S9.388 21 7 21c-2.171 0-5 5.548-5 5.548V14h21l-3-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V19z" }),
  React.createElement("path", { d: "M29.686 5.541l.133 3.659a2.985 2.985 0 0 0 1.524 2.5l3.2 1.79-3.661.132a2.985 2.985 0 0 0-2.5 1.524l-1.79 3.2-.132-3.661a2.985 2.985 0 0 0-1.524-2.5l-3.2-1.79 3.661-.132a2.985 2.985 0 0 0 2.5-1.524z" })
);

